import { NgModule } from '@angular/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelModule } from 'primeng/panel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputMaskModule } from 'primeng/inputmask';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DialogModule } from 'primeng/dialog';
import { PickListModule } from 'primeng/picklist';
import { TabsModule } from 'primeng/tabs';
import { AccordionModule } from 'primeng/accordion';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';

const primeNgModules = [
  AccordionModule,
  AutoCompleteModule,
  ButtonModule,
  CardModule,
  CheckboxModule,
  ConfirmDialogModule,
  DatePickerModule,
  DialogModule,
  IconFieldModule,
  InputIconModule,
  InputMaskModule,
  InputTextModule,
  MenuModule,
  MenubarModule,
  MessageModule,
  MultiSelectModule,
  PanelModule,
  PanelModule,
  PickListModule,
  ProgressSpinnerModule,
  RadioButtonModule,
  SelectModule,
  TableModule,
  TabsModule,
  ToastModule,
  ToggleSwitchModule,
];

@NgModule({
  imports: [...primeNgModules],
  exports: [...primeNgModules]
})
export class PrimeNgModule {}
